var swal = require('sweetalert2');

module.exports = function () {
    $(document).ready(function () {

        var budgetName = $('#js-vip-due-date').data('blockid');

        if(budgetName) {
            $(document).on('click', '#js-vip-due-date', function () {

                swal({
                    title: "due date for " + budgetName,
                    text: "You are about to change the due date for VIP " + budgetName + " for all properties under that Block.",
                    type: "warning",
                    showCancelButton: true
                });
            });
        }
    });
}();
